import PropTypes from 'prop-types';
import { LinkButton } from '@evertrue/et-components';
import { isEmpty } from '@evertrue/sdk';
import StrikeThroughWrapper from 'components/containers/strikethrough-wrapper';

const TaskActionTypeCell = ({
  task,
  user,
  parseActionType,
  trackOutreachAction,
  addDrawer,
  openPinnedCommentModal,
  closePinnedCommentModal,
  isPinnedCommentModalOpen,
  ThankviewCTA,
  getContactEmailAddress,
}) => {
  if (isEmpty(task)) return null;

  const { id, action_type, completed_at, contact, owner_user_id } = task;

  const handleActionTypeClick = (action_type, contact, taskId) => {
    const cAttrs = contact?.contact_attributes;
    const name =
      cAttrs?.name_full?.trim() ||
      [cAttrs?.name_first, cAttrs?.name_last].filter(Boolean).join(' ').trim() ||
      cAttrs?.name_nick?.trim() ||
      null;
    const title = name ?? 'New Message';

    if (action_type === 'EMAIL') {
      trackOutreachAction('open_emailer');
      addDrawer('emailer', {
        contact: contact || {},
        taskId,
        name,
        drawerTitle: title,
      });
    } else if (action_type === 'CALL') {
      trackOutreachAction('open_dialer');
      addDrawer('dialer', {
        contact: contact || {},
        phones: (!isEmpty(contact) && contact.phones) || [],
        name: name,
        drawerTitle: title,
      });
    } else {
      isPinnedCommentModalOpen ? closePinnedCommentModal() : openPinnedCommentModal();
    }
  };

  const handleCopyThankviewVideo = (contact) => {
    const email_address = getContactEmailAddress(contact);

    trackOutreachAction('open_emailer');
    addDrawer('emailer', {
      clickedEmailAddress: email_address,
    });
  };

  return (
    <StrikeThroughWrapper hasStrikeThrough={!!completed_at}>
      {action_type ? (
        owner_user_id === user.id &&
        contact &&
        (['EMAIL', 'CALL'].includes(action_type) || (action_type === 'RESEARCH' && contact !== null)) ? (
          <LinkButton
            title={action_type}
            className="fs-exclude-data"
            style={{ cursor: 'pointer' }}
            onClick={() => handleActionTypeClick(action_type, contact, id)}
          >
            {parseActionType(action_type)}
          </LinkButton>
        ) : action_type === 'THANK_VIEW' ? (
          <ThankviewCTA
            popoverTrigger={
              <LinkButton title={'ThankView'} className="fs-exclude-data" style={{ cursor: 'pointer' }}>
                {parseActionType(action_type)}
              </LinkButton>
            }
            onCopyVideo={() => handleCopyThankviewVideo(contact)}
          />
        ) : (
          <span className="fs-exclude-data">{parseActionType(action_type)}</span>
        )
      ) : null}
    </StrikeThroughWrapper>
  );
};

TaskActionTypeCell.propTypes = {
  task: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  parseActionType: PropTypes.func.isRequired,
  trackOutreachAction: PropTypes.func.isRequired,
  addDrawer: PropTypes.func.isRequired,
  openPinnedCommentModal: PropTypes.func.isRequired,
  closePinnedCommentModal: PropTypes.func.isRequired,
  isPinnedCommentModalOpen: PropTypes.bool.isRequired,
  ThankviewCTA: PropTypes.elementType.isRequired,
  getContactEmailAddress: PropTypes.func.isRequired,
};

export default TaskActionTypeCell;
